export default "__VITE_ASSET__BGBNAily__"